module.exports = __webpack_public_path__ + "static/media/ico-information.41fd250d.svg";